// extracted by mini-css-extract-plugin
export var carousel = "carousel-module--carousel--bb29b";
export var controlStyle = "carousel-module--controlStyle--d3f2f";
export var controls = "carousel-module--controls--8a080";
export var dark = "carousel-module--dark--7adcb";
export var hasText = "carousel-module--hasText--523b1";
export var light = "carousel-module--light--89099";
export var line = "carousel-module--line--4eb64";
export var selected = "carousel-module--selected--fa33a";
export var slide = "carousel-module--slide--97fd4";
export var slider = "carousel-module--slider--38f05";